module.exports = __webpack_public_path__ + "static/assets/698226012c4fa4a0fcfe34f428b87306.svg";